<template>
    <div>
        <vue-headful :title="'Import Zip [Safety Data Sheets] :: MeritEHS'"/>

        <h4 class="py-2 mb-4">
            <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                    <router-link :to="`/safety-data-sheets`">
                        <i class="fa fa-files-o"></i> Safety Data Sheets
                    </router-link>
                </li>
                <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                    <i class="fa fa-file-zip-o"></i> Import Zip
                </li>
            </ol>
        </h4>

        <div class="row mt-4">
            <div class="col-xl-8 col-lg-10 col-md-12">
                <div class="card mb-3">
                    <div class="card-header">Safety Data Sheet - Import ZIP File</div>
                    <div class="card-body">

                        <div v-bind:class="{ 'form-group': true, 'has-error': errors.file }" class="row">
                            <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.file}">
                                Select ZIP File:
                                <i class="fa fa-asterisk text-danger"></i>
                            </label>
                            <div class="col-md-8 col-sm-12">
                                <b-form-file v-model="file" :class="{'is-invalid': errors.file}" placeholder="Select ZIP File of Data Sheets" accept=".zip"></b-form-file>

                                <div v-if="errors.file" class="text-danger">
                                    <span v-for="error in errors.file">{{ error }}</span>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>

        <button type="button" class="btn btn-success" v-on:click="saveSafetyDataSheet(this)" :disabled="saving">
            Import ZIP <i class="fa fa-spinner fa-spin" v-if="saving"></i>
        </button>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                saving: false,
                file: null,
                errors: {},
            }
        },

        computed: {

        },

        methods: {

            saveSafetyDataSheet() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .postWithSingleFile('/safety-data-sheets/import-zip', {}, this.file)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Safety Data Sheet are importing. You will receieve an email when complete.');

                    //Return to main list?
                    this.$router.push('/safety-data-sheets');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },
        },

        mounted() {

        }
    }
</script>
